"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbarContext = exports.SnackbarProvider = exports.SnackbarContext = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Snackbar_1 = require("./Snackbar");
exports.SnackbarContext = (0, react_1.createContext)({ setNotices: () => { }, setOffset: () => { } });
function SnackbarProvider(props) {
    const [notices, setNotices] = (0, react_1.useState)([]);
    const [offset, setOffset] = (0, react_1.useState)({});
    const contextValue = (0, react_1.useMemo)(() => ({ setNotices, setOffset }), []);
    return ((0, jsx_runtime_1.jsxs)(exports.SnackbarContext.Provider, { value: contextValue, children: [props.children, (0, jsx_runtime_1.jsx)(Snackbar_1.Snackbar, { notices: notices, offset: offset })] }));
}
exports.SnackbarProvider = SnackbarProvider;
function useSnackbarContext() {
    return (0, react_1.useContext)(exports.SnackbarContext);
}
exports.useSnackbarContext = useSnackbarContext;
